/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusUploadMiniDto } from '../../models/lexplus-upload-mini-dto';

export interface AufgabenControllerFindDokumenteV1$Params {
  id: number;
}

export function aufgabenControllerFindDokumenteV1(http: HttpClient, rootUrl: string, params: AufgabenControllerFindDokumenteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusUploadMiniDto>>> {
  const rb = new RequestBuilder(rootUrl, aufgabenControllerFindDokumenteV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusUploadMiniDto>>;
    })
  );
}

aufgabenControllerFindDokumenteV1.PATH = '/v1/aufgaben/{id}/dokumente';
